import type React from 'react'

import { MarkerF, type MarkerProps } from '@react-google-maps/api'

import { svgRequestMarker } from '@/components/atoms/MapSvgMarker/svgRequestMarker.ts'

import { markerLabel } from './markerLabel.ts'

export type RequestDestinationMarkerProps = { label: string; children?: React.ReactNode } & Omit<
  MarkerProps,
  'icon' | 'label'
>

export const RequestDestinationMarker: React.FC<RequestDestinationMarkerProps> = ({ label, children, ...props }) => (
  <MarkerF
    {...props}
    label={markerLabel(label, 'onboarded')}
    icon={{
      url: `data:image/svg+xml;utf-8,${encodeURIComponent(svgRequestMarker('onboarded'))}`,
      scaledSize: new google.maps.Size(36, 36),
      labelOrigin: new google.maps.Point(18, 14),
      // Adjustments because of the shadow
      anchor: new google.maps.Point(18, 28),
    }}>
    {children}
  </MarkerF>
)
